import * as Types from '@x/schemas/ecommerce';

import { gql } from 'apollo-angular';
import { ShopMembershipObjectAttributesFragmentDoc } from './shop-membership.gql.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ShopMemberObjectAttributesFragment = { __typename: 'ShopMemberObject', id: number, state: Types.MemberState, channelCode: string, membership?: { __typename: 'ShopMembershipObject', id: number, name: string, slug: string, description?: string | null | undefined, locale: string, contentRef?: string | null | undefined, renewalMessage?: string | null | undefined, termsUrl?: string | null | undefined, activationUrl?: string | null | undefined, meta?: { __typename: 'ShopMetaContentObject', title?: string | null | undefined, description?: string | null | undefined, keywords?: string | null | undefined } | null | undefined } | null | undefined };

export type ShopCreateMemberMutationVariables = Types.Exact<{
  input: Types.ShopCreateMemberInput;
  locale: Types.Scalars['String']['input'];
}>;


export type ShopCreateMemberMutation = { __typename: 'Mutation', shopCreateMember: { __typename: 'ShopMemberObject', id: number, state: Types.MemberState, membership?: { __typename: 'ShopMembershipObject', id: number, name: string } | null | undefined } };

export type ShopMemberByIdQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
  channelCode: Types.Scalars['String']['input'];
  membershipId: Types.Scalars['Int']['input'];
  locale: Types.Scalars['String']['input'];
}>;


export type ShopMemberByIdQuery = { __typename: 'Query', shopMember?: { __typename: 'ShopMemberObject', id: number, state: Types.MemberState, channelCode: string, membership?: { __typename: 'ShopMembershipObject', id: number, name: string, slug: string, description?: string | null | undefined, locale: string, contentRef?: string | null | undefined, renewalMessage?: string | null | undefined, termsUrl?: string | null | undefined, activationUrl?: string | null | undefined, meta?: { __typename: 'ShopMetaContentObject', title?: string | null | undefined, description?: string | null | undefined, keywords?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type ShopMembersQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
  channelCode: Types.Scalars['String']['input'];
  locale: Types.Scalars['String']['input'];
}>;


export type ShopMembersQuery = { __typename: 'Query', shopMembers: Array<{ __typename: 'ShopMemberObject', id: number, state: Types.MemberState, channelCode: string, membership?: { __typename: 'ShopMembershipObject', id: number, name: string, slug: string, description?: string | null | undefined, locale: string, contentRef?: string | null | undefined, renewalMessage?: string | null | undefined, termsUrl?: string | null | undefined, activationUrl?: string | null | undefined, meta?: { __typename: 'ShopMetaContentObject', title?: string | null | undefined, description?: string | null | undefined, keywords?: string | null | undefined } | null | undefined } | null | undefined }> };

export type ShopDeactivateMemberMutationVariables = Types.Exact<{
  input: Types.ShopDeactivateMemberInput;
  locale: Types.Scalars['String']['input'];
}>;


export type ShopDeactivateMemberMutation = { __typename: 'Mutation', shopDeactivateMember: { __typename: 'ShopMemberObject', id: number, state: Types.MemberState, membership?: { __typename: 'ShopMembershipObject', id: number, name: string } | null | undefined } };

export type ShopActivateMemberMutationVariables = Types.Exact<{
  input: Types.ShopActivateMemberInput;
  locale: Types.Scalars['String']['input'];
}>;


export type ShopActivateMemberMutation = { __typename: 'Mutation', shopActivateMember: { __typename: 'ShopMemberObject', id: number, state: Types.MemberState, membership?: { __typename: 'ShopMembershipObject', id: number, name: string } | null | undefined } };

export const ShopMemberObjectAttributesFragmentDoc = gql`
    fragment ShopMemberObjectAttributes on ShopMemberObject {
  id
  state
  channelCode
  membership(locale: $locale) {
    ...ShopMembershipObjectAttributes
  }
}
    ${ShopMembershipObjectAttributesFragmentDoc}`;
export const ShopCreateMemberDocument = gql`
    mutation ShopCreateMember($input: ShopCreateMemberInput!, $locale: String!) {
  shopCreateMember(input: $input) {
    id
    state
    membership(locale: $locale) {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopCreateMemberGQL extends Apollo.Mutation<ShopCreateMemberMutation, ShopCreateMemberMutationVariables> {
    document = ShopCreateMemberDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopMemberByIdDocument = gql`
    query ShopMemberById($userId: Int!, $channelCode: String!, $membershipId: Int!, $locale: String!) {
  shopMember(
    userId: $userId
    channelCode: $channelCode
    membershipId: $membershipId
  ) {
    ...ShopMemberObjectAttributes
  }
}
    ${ShopMemberObjectAttributesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopMemberByIdGQL extends Apollo.Query<ShopMemberByIdQuery, ShopMemberByIdQueryVariables> {
    document = ShopMemberByIdDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopMembersDocument = gql`
    query ShopMembers($userId: Int!, $channelCode: String!, $locale: String!) {
  shopMembers(userId: $userId, channelCode: $channelCode) {
    ...ShopMemberObjectAttributes
  }
}
    ${ShopMemberObjectAttributesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopMembersGQL extends Apollo.Query<ShopMembersQuery, ShopMembersQueryVariables> {
    document = ShopMembersDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopDeactivateMemberDocument = gql`
    mutation ShopDeactivateMember($input: ShopDeactivateMemberInput!, $locale: String!) {
  shopDeactivateMember(input: $input) {
    id
    state
    membership(locale: $locale) {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopDeactivateMemberGQL extends Apollo.Mutation<ShopDeactivateMemberMutation, ShopDeactivateMemberMutationVariables> {
    document = ShopDeactivateMemberDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopActivateMemberDocument = gql`
    mutation ShopActivateMember($input: ShopActivateMemberInput!, $locale: String!) {
  shopActivateMember(input: $input) {
    id
    state
    membership(locale: $locale) {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopActivateMemberGQL extends Apollo.Mutation<ShopActivateMemberMutation, ShopActivateMemberMutationVariables> {
    document = ShopActivateMemberDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }